/** Session cache for blog HTML preview when server draft is not reachable yet. */
export const blogLivePreviewStorageKey = (blogId: string) => `blog-live-preview:${blogId.trim()}`;

export type BlogLivePreviewCache = {
  campaignId: string;
  blogId: string;
  supplierId?: string;
  title?: string;
  cmsTemplateJson?: unknown;
};

export function readBlogLivePreviewCache(blogId: string): BlogLivePreviewCache | null {
  try {
    const raw = globalThis.sessionStorage.getItem(blogLivePreviewStorageKey(blogId));
    if (!raw) return null;
    return JSON.parse(raw) as BlogLivePreviewCache;
  } catch {
    return null;
  }
}

export function cacheBlogLivePreview(payload: BlogLivePreviewCache): void {
  try {
    globalThis.sessionStorage.setItem(
      blogLivePreviewStorageKey(payload.blogId),
      JSON.stringify(payload),
    );
  } catch {
    /* ignore quota / private mode */
  }
}
